<template>
  <div class="vip-page">
    <div class="vip-header">
      <div class="vip-brand">
        <img src="@/assets/daohan-logo.png" alt="道晗漫画平台" class="vip-brand-logo">
        <div>
          <p>道晗漫画平台</p>
          <h1>充值服务</h1>
          <div class="vip-slogan">开通VIP会员，畅享全站漫画特权</div>
        </div>
      </div>
    </div>

    <div class="vip-container vip-checkout-layout">
      <aside class="vip-benefits">
        <div class="vip-panel-heading">
          <p>VIP BENEFITS</p>
          <h2>会员特权</h2>
        </div>
        <div class="benefit-list">
          <div class="benefit-item" v-for="(benefit, index) in vipBenefits" :key="index">
            <div class="benefit-icon" v-html="benefit.icon"></div>
            <div class="benefit-content">
              <div class="benefit-title">{{ benefit.name }}</div>
              <div class="benefit-desc">{{ benefit.desc }}</div>
            </div>
          </div>
        </div>
      </aside>

      <main class="vip-packages">
        <div class="vip-panel-heading">
          <p>VIP PLANS</p>
          <h2>选择套餐</h2>
        </div>
        <div class="youth-recharge-notice" v-if="youthRechargeBlocked">
          <strong>青少年模式已开启</strong>
          <span>当前无法充值或开通会员，请先完成成年人密码认证。</span>
        </div>
        <div class="minor-consume-notice" v-else-if="!realnameStatus.verified">
          <strong>实名提示</strong>
          <span>依据《未成年人网络保护条例》，本站消费实行实名与限额管理：未满8周岁禁止消费；8-15周岁单次不超过50元、每月不超过200元；16-17周岁单次不超过100元、每月不超过400元。请先在「个人中心-设置-实名认证」完成实名。</span>
        </div>
        <div class="minor-consume-notice ok" v-else-if="realnameStatus.is_minor">
          <strong>未成年账号</strong>
          <span>已完成实名认证，消费将按限额管理（8-15周岁单次≤50元/月≤200元；16-17周岁单次≤100元/月≤400元）。</span>
        </div>
        <div class="packages-loading" v-if="isLoading">
          <div class="spinner"></div>
          <p>加载中...</p>
        </div>
        <div class="packages-list" v-else>
          <div 
            v-for="pkg in packages" 
            :key="pkg.id" 
            class="package-item"
            :class="{ active: selectedPackage === pkg.id, disabled: youthRechargeBlocked }"
            @click="selectPackage(pkg.id)"
          >
            <div class="package-name">{{ pkg.name }}</div>
            <div class="package-price">¥{{ pkg.price }}</div>
            <div class="package-duration">{{ pkg.duration }}天</div>
            <div class="package-desc">{{ pkg.description }}</div>
          </div>
        </div>

        <!-- 支付按钮 -->
        <div class="payment-section">
          <button 
            class="payment-btn" 
            :disabled="!selectedPackage || isProcessing || youthRechargeBlocked" 
            @click="showPayment"
          >
            {{ youthRechargeBlocked ? '青少年模式下不可充值' : (isProcessing ? '处理中...' : '立即开通') }}
          </button>
        </div>
      </main>

      <div class="vip-agreement">
        <p>开通会员即表示您同意《VIP会员服务协议》</p>
      </div>
    </div>

    <!-- 支付弹窗 -->
    <div class="payment-modal" v-if="showPaymentModal && !youthRechargeBlocked">
      <div class="payment-content">
        <div class="payment-header">
          <h3>会员开通</h3>
          <span class="close-btn" @click="closePayment">×</span>
        </div>
        <div class="payment-body">
          <div class="package-info">
            <h4>{{ selectedPackageInfo.name }}</h4>
            <p class="price">¥{{ selectedPackageInfo.price }}</p>
            <p class="duration">有效期: {{ selectedPackageInfo.duration }}天</p>
          </div>
          <div class="qrcode-container">
            <img src="../assets/qrcode.png" alt="支付二维码">
            <p>请使用支付宝扫码支付</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, computed, onMounted } from 'vue'
import api from '../api/index'
import { initYouthStore, isYouthRechargeRestricted } from '../utils/youthContent'

export default {
  name: 'VipPage',
  setup() {
    const packages = ref([])
    const isLoading = ref(true)
    const isProcessing = ref(false)
    const selectedPackage = ref(null)
    const showPaymentModal = ref(false)
    const youthRechargeBlocked = computed(() => isYouthRechargeRestricted())
    const realnameStatus = ref({ verified: false, is_minor: false, masked_name: '' })

    const loadRealnameStatus = async () => {
      try {
        const res = await api.getRealnameStatus()
        if (res && res.code === 1 && res.data) {
          realnameStatus.value = res.data
        }
      } catch (e) {
        // 未登录或异常时保持未认证展示
      }
    }

    const vipBenefits = reactive([
      { 
        icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>', 
        name: '全站漫画免费阅读', 
        desc: '畅享所有漫画内容，无需单独付费' 
      },
      { 
        icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>', 
        name: '新漫画提前更新', 
        desc: '比普通用户提前12小时阅读最新内容' 
      },
      { 
        icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12v6a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-6"></path><rect x="2" y="6" width="20" height="6" rx="1"></rect></svg>', 
        name: '每月赠送100积分', 
        desc: '可用于兑换虚拟礼品和特权服务' 
      },
      { 
        icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M12 15c-1.93 0-3.5-1.57-3.5-3.5S10.07 8 12 8s3.5 1.57 3.5 3.5S13.93 15 12 15z"></path><path d="M19.07 4.93C15.17 1.03 8.83 1.03 4.93 4.93c-3.9 3.9-3.9 10.24 0 14.14 3.9 3.9 10.24 3.9 14.14 0 3.9-3.9 3.9-10.24 0-14.14zm-1.41 12.73C14.86 20.46 9.14 20.46 6.34 17.66c-2.8-2.8-2.8-8.52 0-11.32 2.8-2.8 8.52-2.8 11.32 0 2.8 2.8 2.8 8.52 0 11.32z"></path></svg>', 
        name: '专属会员标识', 
        desc: '在评论区展示VIP专属标识' 
      },
      { 
        icon: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12" y2="18"></line></svg>', 
        name: '多端同步', 
        desc: '手机、平板、电脑多端阅读同步' 
      }
    ])

    // 获取所选套餐的详细信息
    const selectedPackageInfo = computed(() => {
      const pkg = packages.value.find(p => p.id === selectedPackage.value)
      return pkg || {}
    })

    // 获取VIP套餐列表
    const fetchPackages = async () => {
      try {
        isLoading.value = true
        const response = await api.getVipPackages()
        console.log('获取VIP套餐列表结果:', response)
        
        if (response && response.code === 1 && response.data) {
          packages.value = response.data
          // 默认选中第一个套餐
          if (packages.value.length > 0 && !selectedPackage.value) {
            selectedPackage.value = packages.value[0].id
          }
        } else {
          console.error('获取VIP套餐列表返回格式错误:', response)
        }
      } catch (error) {
        console.error('获取VIP套餐列表异常:', error)
      } finally {
        isLoading.value = false
      }
    }

    // 选择套餐
    const selectPackage = (id) => {
      if (youthRechargeBlocked.value) return
      selectedPackage.value = id
    }

    // 显示支付弹窗
    const showPayment = () => {
      if (youthRechargeBlocked.value) return
      if (!selectedPackage.value) return
      showPaymentModal.value = true
    }

    // 关闭支付弹窗
    const closePayment = () => {
      showPaymentModal.value = false
    }

    // 在组件挂载时获取VIP套餐列表
    onMounted(() => {
      initYouthStore()
      fetchPackages()
      loadRealnameStatus()
    })

    return {
      packages,
      isLoading,
      isProcessing,
      selectedPackage,
      vipBenefits,
      showPaymentModal,
      youthRechargeBlocked,
      realnameStatus,
      selectedPackageInfo,
      selectPackage,
      showPayment,
      closePayment
    }
  }
}
</script>

<style scoped>
.vip-page {
  padding: 34px 20px 54px;
  max-width: 1500px;
  margin: 0 auto;
  color: #eef3ff;
}

.vip-header {
  margin-bottom: 28px;
  padding: 28px;
  border-radius: 10px;
  background:
    radial-gradient(circle at 85% 18%, rgba(255, 204, 102, 0.22), transparent 28%),
    linear-gradient(135deg, rgba(23, 28, 48, 0.98), rgba(8, 11, 20, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 30px 76px rgba(0, 0, 0, 0.34);
}

.vip-brand {
  display: flex;
  align-items: center;
  gap: 24px;
}

.vip-brand-logo {
  width: 170px;
  height: 120px;
  object-fit: contain;
  border-radius: 8px;
  background: #fff;
  padding: 10px;
  box-shadow: 0 18px 46px rgba(23, 34, 63, 0.12);
}

.vip-brand p {
  margin: 0 0 8px;
  color: #12aeb8;
  font-size: 15px;
  font-weight: 900;
}

.vip-header h1 {
  font-size: 42px;
  color: #f8fbff;
  margin-bottom: 10px;
  letter-spacing: 0;
}

.vip-slogan {
  font-size: 16px;
  color: #9faaca;
}

.vip-container {
  background: linear-gradient(180deg, rgba(18, 22, 38, 0.96), rgba(9, 12, 22, 0.98));
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 26px 68px rgba(0, 0, 0, 0.32);
  overflow: hidden;
}

.vip-checkout-layout {
  display: grid;
  grid-template-columns: minmax(300px, 0.82fr) minmax(0, 1fr);
}

.vip-panel-heading {
  margin-bottom: 20px;
}

.vip-panel-heading p {
  margin: 0 0 8px;
  color: #ffcc66;
  font-size: 13px;
  font-weight: 900;
}

.vip-panel-heading h2 {
  margin: 0;
  color: #f8fbff;
  font-size: 34px;
}

/* VIP特权部分 */
.vip-benefits {
  padding: 32px;
  background:
    radial-gradient(circle at 92% 12%, rgba(35, 211, 238, 0.22), transparent 30%),
    linear-gradient(135deg, #101522, #070912);
  color: #fff;
}

.vip-benefits h2 {
  font-size: 24px;
  margin-bottom: 20px;
  font-weight: 500;
}

.benefit-list {
  display: grid;
  grid-template-columns: 1fr;
  gap: 14px;
}

.benefit-item {
  display: flex;
  align-items: flex-start;
  background-color: rgba(255, 255, 255, 0.12);
  padding: 18px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition: transform 0.3s;
}

.benefit-item:hover {
  transform: translateY(-5px);
  background-color: rgba(255, 255, 255, 0.2);
}

.benefit-icon {
  font-size: 24px;
  margin-right: 12px;
  margin-top: 2px;
}

.benefit-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 5px;
}

.benefit-desc {
  font-size: 14px;
  opacity: 0.8;
}

/* VIP套餐部分 */
.vip-packages {
  padding: 32px;
}

.vip-packages h2 {
  font-size: 24px;
  margin-bottom: 20px;
  color: #f8fbff;
  font-weight: 500;
}

.packages-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px 0;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-left-color: #22d3d7;
  animation: spin 1s linear infinite;
  margin-bottom: 15px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.packages-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.package-item {
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 22px;
  cursor: pointer;
  position: relative;
  transition: all 0.3s;
  background: rgba(255, 255, 255, 0.05);
}

.package-item:hover {
  border-color: #22d3d7 !important;
  transform: translateY(-5px);
  box-shadow: 0 18px 38px rgba(34, 211, 215, 0.14) !important;
}

.package-item.active {
  border-color: #22d3d7 !important;
  background: linear-gradient(180deg, rgba(34, 211, 215, 0.18), rgba(23, 34, 63, 0.14)) !important;
  box-shadow: inset 0 0 0 2px #22d3d7, 0 18px 42px rgba(34, 211, 215, 0.24) !important;
  transform: translateY(-4px);
}

.package-item.active .package-name {
  color: #22d3d7 !important;
}

.package-item.active .package-price {
  color: #ffcc66 !important;
}

.package-item.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.package-item.disabled:hover {
  border-color: rgba(255, 255, 255, 0.1);
  transform: none;
  box-shadow: none;
}

.package-name {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 10px;
  color: #f8fbff;
}

.package-price {
  font-size: 24px;
  font-weight: bold;
  color: #ffcc66;
  margin-bottom: 5px;
}

.package-duration {
  font-size: 14px;
  color: #9faaca;
  margin-bottom: 10px;
}

.package-desc {
  font-size: 13px;
  color: #9faaca;
}

/* 支付部分 */
.payment-section {
  text-align: center;
  margin-top: 20px;
}

.youth-recharge-notice {
  display: grid;
  gap: 4px;
  margin: 0 0 18px;
  padding: 14px 16px;
  border: 1px solid rgba(255, 180, 72, 0.42);
  border-radius: 8px;
  background: rgba(255, 180, 72, 0.1);
  color: #ffd58a;
}

.youth-recharge-notice strong {
  color: #ffcc66;
}

.youth-recharge-notice span {
  color: #b8c2dc;
  font-size: 14px;
}

.minor-consume-notice {
  margin: 0 0 18px;
  padding: 14px 16px;
  border: 1px solid rgba(82, 196, 26, 0.4);
  border-radius: 8px;
  background: rgba(82, 196, 26, 0.08);
  color: #b7e4a0;
}

.minor-consume-notice strong {
  color: #a8e063;
  display: block;
  margin-bottom: 4px;
}

.minor-consume-notice span {
  color: #9fb8c8;
  font-size: 14px;
  line-height: 1.6;
}

.minor-consume-notice.ok {
  border-color: rgba(34, 211, 215, 0.4);
  background: rgba(34, 211, 215, 0.08);
}

.payment-btn {
  background: linear-gradient(135deg, #22d3d7, #17223f);
  color: white;
  border: none;
  border-radius: 30px;
  padding: 12px 40px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s;
}

.payment-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 28px rgba(34, 211, 215, 0.22);
}

.payment-btn:disabled {
  background: #cccccc;
  cursor: not-allowed;
  transform: none;
  box-shadow: none;
}

/* 用户协议 */
.vip-agreement {
  grid-column: 1 / -1;
  text-align: center;
  font-size: 12px;
  color: #999;
  margin-top: 20px;
  padding-bottom: 20px;
}

/* 支付弹窗 */
.payment-modal {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.payment-content {
  background-color: #111525;
  width: 400px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.payment-header {
  padding: 15px 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.payment-header h3 {
  margin: 0;
  font-size: 18px;
  color: #f8fbff;
}

.close-btn {
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #666;
}

.payment-body {
  padding: 20px;
  text-align: center;
}

.package-info {
  margin-bottom: 20px;
}

.package-info h4 {
  font-size: 18px;
  margin-bottom: 10px;
}

.package-info .price {
  font-size: 24px;
  color: #ffcc66;
  font-weight: bold;
  margin-bottom: 5px;
}

.package-info .duration {
  font-size: 14px;
  color: #9faaca;
}

.qrcode-container {
  margin: 20px auto;
}

.qrcode-container img {
  width: 180px;
  height: 180px;
  border: 1px solid #f0f0f0;
  padding: 10px;
}

.qrcode-container p {
  margin-top: 15px;
  font-size: 14px;
  color: #9faaca;
}

@media (max-width: 768px) {
  .vip-checkout-layout {
    grid-template-columns: 1fr;
  }

  .vip-header {
    padding: 20px;
  }

  .vip-brand {
    align-items: flex-start;
    flex-direction: column;
  }

  .vip-brand-logo {
    width: 150px;
    height: 104px;
  }

  .vip-header h1 {
    font-size: 32px;
  }

  .benefit-list {
    grid-template-columns: 1fr;
  }
  
  .packages-list {
    grid-template-columns: 1fr;
  }
}
</style> 
